// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sexbox{display:flex;margin-left:10px}.sexbox img{height:20px;width:16px;display:inline-block}.sex{width:60px;text-align:center;border:1px solid #f5f5f5;cursor:pointer;display:flex;justify-content:center;align-items:center;margin-left:8px}.sexbox .select{border-color:#ee1d23}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
